<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>Invitation EDM
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>

    <div class="articleEn">
      <div>
        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span
                  class="font-weight-bold text-primary"
                  style="font-size: 16px"
                  v-if="item.MenuName == 'Invitation EDM'"
                >
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconInvite.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="MbDevice">
              <!-- <h1> <img src="../images/iconInvite.svg" width="35px" class="mb-1"> Invitation EDM</h1> -->

              <div class="d-flex justify-content-between align-items-center">
                <!-- <div>
                  <h1><img src="@/assets/images/iconInvite.svg" width="35px" class="mb-2" /> Invitation EDM</h1>
                </div> -->

                <div class="d-flex align-items-center">
                  <div>
                    <img src="@/assets/images/iconInvite.svg" width="35px" class="mt-1 mr-1" />
                  </div>
                  <div>
                    <h1>Invitation EDM</h1>
                  </div>
                </div>
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                        <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>Invitation EDM</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p>
              You can generate exclusive invitation code and e-invitation (EDM). You can forward the EDM or copy its URL
              to your clients. Those invited would be able to visit the exhibition once they have finished their
              Visiting Eligibility Application.
            </p>
            <p class="my-3">&nbsp;</p>
            <ol class="number">
              <li>Once the customer finished registration, it will be included in the quota calculation.</li>
              <li>If you need more quota please contact our sales</li>
              <li>
                * The application is available until <span class="red"><span name="CloseDay"></span> 23:59</span> , it
                will be unavailable during the exhibition.
              </li>
            </ol>
            <p class="lightLine">&nbsp;</p>
            <h3>Exclusive Invitation Code</h3>
            <p class="my-3">&nbsp;</p>

            <div v-if="!hasAccountId">
              <div class="alert alert-danger" role="alert">
                <img src="@/assets/images/tickGray.svg" width="16px" class="mb-1 mr-1" alt="" />
                The process of your code application is not successful, and please reach the contact of exhibition for
                further actions.
              </div>

              <h3 class="mt-4 mb-3">Contact</h3>
              <div name="ExpoContact"></div>
            </div>

            <div v-else>
              <p>Below is your invitation code. The following are the status of your clients registered.</p>
              <p class="my-3">&nbsp;</p>
              <div class="grayBG">
                <p>Invitation code：<span name="InvitationCode"></span></p>
                <p>Used：<span class="red" name="InvitationUsed"></span> / <span name="InvitationQuota"></span></p>
              </div>

              <div class="OpenBothInvite">
                <p class="lightLine">&nbsp;</p>
                <h3>Send E-Invitation</h3>
                <p class="my-3">&nbsp;</p>
                <p>Please forward the E-Invitation or copy the E-invitation URL to your VIP clients!</p>
                <p class="my-3">&nbsp;</p>
                <!-- tw -->
                <div class="ShowPhyInvite">
                  <h4 class="mb-4">
                    <span style="padding-bottom: 1px; border-bottom: 1px solid rgb(0, 0, 0)">
                      Physical exhibition E-Invitation
                    </span>
                  </h4>
                  <div class="left">
                    <div class="grayBG">
                      <p class="bold">Physical exhibition E-Invitation (Chinese)</p>
                      <p name="InvitationCodeHash"></p>
                      <input name="InvitationCodeHash" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <div class="btnStyle mr-2" @click.prevent="SendEnMail('tw')">Send</div>
                      <input type="button" value="Copy" class="btnStyle copyURL" />
                    </div>
                  </div>
                  <!-- tw end -->
                  <!-- en -->
                  <div class="right">
                    <div class="grayBG">
                      <p class="bold">Physical exhibition E-Invitation (English)</p>
                      <p name="InvitationCodeHashEn"></p>
                      <input name="InvitationCodeHashEn" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <div class="btnStyle mr-2" @click.prevent="SendEnMail('en')">Send</div>
                      <input type="button" value="Copy" class="btnStyle copyURL" />
                    </div>
                  </div>
                </div>

                <p class="clear"></p>

                <div class="ShowOnlineInvite">
                  <h4 class="my-4">
                    <span style="padding-bottom: 1px; border-bottom: 1px solid rgb(0, 0, 0)">
                      Online exhibition E-Invitation
                    </span>
                  </h4>

                  <div class="left">
                    <div class="grayBG">
                      <p class="bold">Online exhibition E-Invitation (Chinese)</p>
                      <p name="OnlineInvitationCodeHash"></p>
                      <input name="OnlineInvitationCodeHash" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <div class="btnStyle mr-2" @click.prevent="OnlineSendMailEn('tw')">Send</div>
                      <input type="button" value="Copy" class="btnStyle copyURL" />
                    </div>
                  </div>
                  <!-- tw end -->
                  <!-- en -->
                  <div class="right">
                    <div class="grayBG">
                      <p class="bold">Online exhibition E-Invitation (English)</p>
                      <p name="OnlineInvitationCodeHashEn"></p>
                      <input name="OnlineInvitationCodeHashEn" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <div class="btnStyle mr-2" @click.prevent="OnlineSendMailEn('en')">Send</div>
                      <input type="button" value="Copy" class="btnStyle copyURL" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- en end -->
            <p class="clear"></p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: `Invitation EDM - Chan Chao Exhibitor's Online Service System`,
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        date: '',
        lang: 'en',
        openOnlineInvite: '',
        openPhyInvite: '',
        Company_Code: '',
        AppNo: '',
        hasOnlineExh: '',
        hasPhyExh: '',
        ID_error: true,
        hasAccountId: true,
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },
    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
      SendMail(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInvitation/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('實體展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。')
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email發生錯誤！')
          }
        })
      },

      SendEnMail(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInvitation/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('Physical exhibition E-invitation has been sent to your email. You can send it to your VIP clients.')
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('System is busy, please try again later.')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email error！')
          }
        })
      },

      OnlineSendMail(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInviteReg/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
          Type: 'Online',
        }

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('線上展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。')
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email發生錯誤！')
          }
        })
      },

      OnlineSendMailEn(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInviteReg/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
          Type: 'Online',
        }

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('Online exhibition E-invitation has been sent to your email. You can send it to your VIP clients.')
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('System is busy, please try again later.')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email error！')
          }
        })
      },
    },

    created() {
      const vm = this

      //取得語系

      let lang = 'en'

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得當前時間
      let theDate = new Date()
      vm.date = `${theDate.getFullYear()}/${theDate.getMonth() + 1}/${theDate.getDate()}`

      //取得是否開啟線上展權限
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        // console.log(response.data.Data)

        vm.openOnlineInvite = response.data.Data.OnlineExpo_Archived
        vm.openPhyInvite = response.data.Data.PhysicalExpo_Archived

        //判定是否開放兩展邀請函

        if (vm.openOnlineInvite == 1 || vm.openPhyInvite == 1) {
          $('.OpenBothInvite').addClass('ShowInviteTopic')
          $('.OpenBothInvite').removeClass('HideInviteTopic')
        } else {
          $('.OpenBothInvite').addClass('HideInviteTopic')
          $('.OpenBothInvite').removeClass('ShowInviteTopic')
        }

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue

        //取得是否有線上展
        axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
          // console.log(response.data.Data)
          vm.hasOnlineExh = response.data.Data.Virtual
          vm.hasPhyExh = response.data.Data.physical
          vm.Company_Code = response.data.Data.Company_Code
          vm.AppNo = response.data.Data.AppNo

          let AccountID = response.data.Data.AccountID

          if (!AccountID) {
            vm.hasAccountId = false

            $.getJSON('/apiExhibitors/ExpoContact/' + vm.RegNo + '?lang=' + lang, function (data) {
              $('[name="ExpoContact"]').html(data.Data.ExpoContact)
            })
          } else {
            vm.hasAccountId = true
          }

          //判定開放實體邀請函

          if (vm.openPhyInvite == 1 && vm.hasPhyExh == 1) {
            $('.ShowPhyInvite').addClass('ShowInviteTopic')
            $('.ShowPhyInvite').removeClass('HideInviteTopic')
          } else {
            $('.ShowPhyInvite').addClass('HideInviteTopic')
            $('.ShowPhyInvite').removeClass('ShowInviteTopic')
          }
          //判定開放線上展邀請函

          if (vm.openOnlineInvite == 1 && vm.hasOnlineExh == 1) {
            $('.ShowOnlineInvite').addClass('ShowInviteTopic')
            $('.ShowOnlineInvite').removeClass('HideInviteTopic')
          } else {
            $('.ShowOnlineInvite').addClass('HideInviteTopic')
            $('.ShowOnlineInvite').removeClass('ShowInviteTopic')
          }

          //get invitation data
          $.getJSON('/apiExhibitors/Invitation/' + vm.RegNo, function (data) {
            // console.log(data)
            $('[name="InvitationCode"]').text(data.Data.InvitationCode)
            $('[name="InvitationQuota"]').text(data.Data.InvitationQuota)
            $('[name="InvitationUsed"]').text(data.Data.InvitationUsed)

            //tw URL
            let InvitationCodeHash =
              'https://www.chanchao.com.tw/visitorInvitation/edm.asp?code=' +
              data.Data.InvitationCodeHash +
              '&sno=' +
              vm.AppNo
            $('[name="InvitationCodeHash"]').text(InvitationCodeHash).val(InvitationCodeHash)
            //en URL
            let InvitationCodeHashEn =
              'https://www.chanchao.com.tw/en/visitorInvitation/edm.asp?code=' +
              data.Data.InvitationCodeHash +
              '&sno=' +
              vm.AppNo
            $('[name="InvitationCodeHashEn"]').text(InvitationCodeHashEn).val(InvitationCodeHashEn)

            //Online tw URL
            let OnlineInvitationCodeHash =
              'https://www.chanchao.com.tw/visitorInvitation/edm_reg_onlineexpo.asp?code=' +
              vm.Company_Code +
              '&sno=' +
              vm.AppNo +
              '&rno=' +
              vm.RegNo
            $('[name="OnlineInvitationCodeHash"]').text(OnlineInvitationCodeHash).val(OnlineInvitationCodeHash)

            //Online en URL
            let OnlineInvitationCodeHashEn =
              'https://www.chanchao.com.tw/en/visitorInvitation/edm_reg_onlineexpo.asp?code=' +
              vm.Company_Code +
              '&sno=' +
              vm.AppNo +
              '&rno=' +
              vm.RegNo
            $('[name="OnlineInvitationCodeHashEn"]').text(OnlineInvitationCodeHashEn).val(OnlineInvitationCodeHashEn)
          })
        })
      })

      // $.ajaxSettings.async = false; //關閉非同步執行
      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        // console.log(data)

        //close day 展覽前一天23:59
        var CloseDay = new Date(data.Data.ExhBegin)
        CloseDay.setDate(CloseDay.getDate() - 1)
        $('[name="CloseDay"]').text(formatDate(CloseDay))
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        // $.ajaxSettings.async = true; //開啟非同步執行

        //copy edm URL
        $('.copyURL').click(function () {
          let copyText = $(this).parent().parent().find('.hiddenInput')
          copyText.select()
          document.execCommand('Copy')

          if (vm.lang == 'tw') {
            alert('網址已複製')
          } else {
            alert('URL copied')
          }
        })
      })

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)
          vm.MenuInvitation = response.data.Data
        })
    },
  }
</script>

<style lang="scss">
  .alert-danger {
    background-color: #f8d7da;
  }

  .alert {
    padding: 10px 10px;
    font-size: 15px;
  }
</style>
